module.exports = __webpack_public_path__ + "static/step1-790958fc8fbc542162b423031261edb6.mp4";